import { render, staticRenderFns } from "./badgeRank.vue?vue&type=template&id=2646ef9a&scoped=true"
import script from "./badgeRank.vue?vue&type=script&lang=js"
export * from "./badgeRank.vue?vue&type=script&lang=js"
import style0 from "./badgeRank.vue?vue&type=style&index=0&id=2646ef9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646ef9a",
  null
  
)

export default component.exports